<template>
  <!-- <div v-if='menu' class='menuDetail' :class="{sub: menu.originalImagePath == ''}"> -->
  <div v-if='menu' class='menuDetail sub'>
    <MenuDetailHeader :menuName='menu.name' @reloadMainPage="reloadMainPage()" @allMenuToggleEmit="allMenuToggleChange" :menu="menu"/>
    <!-- container -->
    <div id='container'>
      <!-- 상품 정보 -->
      <MenuDataContainer
        :menu='menu'
        :count.sync='count'
        :ableOrderFlag='ableOrderFlag'
        :userCode='userCode'
        :storeGroupCode='storeGroupCode'
        :storeCode='storeCode'
        @showAddMenuDialog='showAddMenuDialog'/>
      <!-- 옵션 정보 -->
      <ul class='viewList'>
        <!-- 무료/유료 옵션 -->
        <li v-for='option in menu.option' :key='option.menuOptionCode' class='li'>
          <NormalOptionContainer
            :optionItem='option'
            :options='options'
            :price.sync='price'/>
        </li>
        <!-- 추가옵션 -->
        <li v-if='menu.additionalOption && menu.additionalOption.length > 0' class='li'>
          <ExtraOptionContainer
            :additionalOption='menu.additionalOption'
            :extraOptions='extraOptions'
            :price.sync='price'/>
        </li>
        <!-- 선택옵션 -->
        <li v-for='optionalOption in menu.optionalOption' :key='optionalOption.menuOptionCode' class='li'>
          <OptionalOptionContainer
            :optionItem='optionalOption'
            :optionalOptions='optionalOptions'
            :optionalCheckBoxList='optionalCheckBoxList'
            :price.sync='price'/>
        </li>
        <li class='li origin' v-if="this.companyType == 4 && menu.origin">
          <dl>
            <dt>{{$t('originOfIngredients')}}</dt>
            <dd style='white-space: pre-line'>{{menu.origin}}</dd>
          </dl>
        </li>
      </ul>
    </div>
    <!-- Footer -->
    <div id='fixFootWrap' :class="appFlag ?  '' : 'fixPt4'">
      <!-- 주문 불가 -->
      <div v-show="bottomShow">
        <div v-if='!ableOrderFlag || !alive' class='in'>
          <div class='row soldOutMsg'>
            <div class='col point1'>{{$t(disableOrderMsg)}}
              <div v-if='!alive || !ableOrderFlag'>{{$t('inPreparation')}}</div>
            </div>
          </div>
        </div>
        <div v-else-if="typeof openAreaDeliveryAble !== 'undefined' && !openAreaDeliveryAble" class='in'>
          <div class='row soldOutMsg'>
            <div class='col point1'>{{$t(disableOrderMsg)}}
              <div>{{ $t('notAvailableDeliveryArea') }}</div>
            </div>
          </div>
        </div>
        <MenuDetailFooter v-else
          :riderInfo="riderInfo"
          :count='count' :price='price'
          :cartMenuNo='cartMenuNo'
          :appCartLength="appCartLength"
          @addCart='soldoutCheck(0)' @order='soldoutCheck(1)'/>
      </div>
    </div>
    <AppAllMenuPopup
      v-if="allMenuToggle"
      @allMenuToggleEmit="allMenuToggleChange"
      @pwdToggleChange="pwdToggleChange"
    />
    <AppChangePassword
      v-if="pwdToggle"
      @pwdToggleChange="pwdToggleChange"
      @showSingleBtnDialog="showSingleBtnDialog"
      class="pop-top"
    />
    <AdultSingleBtnDialog
      v-if='showAdultSingleBtnDialogFlag'
      :messageType='adultSingleBtnMsgType'
      @adultOnClickConfirmBtn="adultOnClickConfirmBtn"/>
    <SingleBtnDialog
      v-if='showSingleBtnDialogFlag'
      :messageType='singleBtnMsgType'
      :onClickConfirmBtn='onClickConfirmBtn'
      :imgFlag='singleImgFlag'/>
    <CartPopUp :cart='cart' :extraMenu='extraMenu'/> <!-- 카트 PopUp -->
    <AppModal
      v-show="modalToggle"
      :message="message"
      :btnCase="btnCase"
      @modalCancel="modalCancel"
      @modalCheck="modalCheck"
    />
    <DoubleBtnDialog
      v-if='showDoubleBtnDialogFlag'
      :message='doubleBtnMsgType'
      :onClickConfirmBtn='onClickConfirmBtn'
      :onClickCancelBtn='onClickCancelBtn'
      :imgFlag='false'
    />
  </div>
</template>
<script lang="js">
/* eslint-disable eqeqeq */
import DoubleBtnDialog from '@/components/Dialog/DoubleBtnDialog.vue'
import SingleBtnDialog from '@/components/Dialog/SingleBtnDialog.vue'
import MenuDetailHeader from '@/components/Header/MenuDetailHeader.vue'
import AppChangePassword from '@/views/AppChangePassword.vue'
import MenuDataContainer from '@/components/MenuDetail/MenuDataContainer.vue'
import AdultSingleBtnDialog from '@/components/Dialog/AdultSingleBtnDialog.vue'
import NormalOptionContainer from '@/components/MenuDetail/NormalOptionContainer.vue'
import ExtraOptionContainer from '@/components/MenuDetail/ExtraOptionContainer.vue'
import OptionalOptionContainer from '@/components/MenuDetail/OptionalOptionContainer.vue'
import MenuDetailFooter from '@/components/Footer/MenuDetailFooter.vue'
import CartPopUp from '@/components/PopUp/CartPopUp.vue'
import { MENU_DETAIL_NAME } from '@/utils/EndPoint'
import { MSG_ADD_MY_MENU, DISABLE_MAKE_MENU_MSG, MESSAGE_DOUBLE_BUTTON } from '@/utils/Message'
import { SET_MENU_CODE, CHANGE_LOGIN_AUTH_FLAG, REQ_MENU_DETAIL, ADD_CART_ITEM, SET_DIRECTFLAG } from '@/store/_actions/actionTypes'
import { DISABLE_MAKE_MENU } from '@/utils/Code'
import { THROW_MAIN, THROW_ORDER, THROW_NON_EXIST_DATA } from '@/router/index'
import { payDirectly } from '@/utils/Methods'
import service from '@/backend/modnpay_app_api'
import Vue from 'vue'
import CloneDeep from 'lodash'
export default Vue.extend({
  name: MENU_DETAIL_NAME,
  props: ['menuCode'],
  components: {
    DoubleBtnDialog,
    MenuDetailHeader,
    SingleBtnDialog,
    MenuDataContainer,
    NormalOptionContainer,
    MenuDetailFooter,
    ExtraOptionContainer,
    OptionalOptionContainer,
    CartPopUp, // 카트 PopUp
    AdultSingleBtnDialog,
    AppChangePassword
  },
  data () {
    return {
      cart: undefined, // 카트에 보여줄 cart
      menu: undefined, // 상품 상제 정보
      alive: this.$store.getters.alive, // pos on/off
      ableOrderFlag: this.$store.getters.ableOrderFlag, // 상품 주문 가능 여부
      showAdultSingleBtnDialogFlag: false,
      adultSingleBtnMsgType: 0,
      confirmType: '',
      disableOrderMsg: '', // 상품 조리 불가 메세지
      showSingleBtnDialogFlag: false, // single btn Dialog show flag
      singleBtnMsgType: 0, // single Btn Dialog의 message type
      onClickConfirmBtn: undefined, // single Btn Dialog에서 확인 버튼 click event
      options: {}, // 선택한 무료/유료 옵션
      extraOptions: {}, // 선택한 추가옵션
      optionalOptions: {}, // 선택한 선택옵션
      optionalCheckBoxList: [], // 선택옵션 체크 리스트 {menuOptionCode, menuOptionName, isValidFlag}
      count: 1, // 선택한 상품 개수
      price: 0, // 상품 기본 가격 + 옵션 가격
      orderDescMethod: this.$store.getters.orderDescMethod, // true: 상품별 주문 요청 사항
      cartMenuNo: this.$store.getters.cartMenuNo, // 카트에 담긴 상품 개수
      currentStoreCode: this.$store.getters.currentStoreCode, // current store code
      categoryCode: this.$store.getters.currentCategoryCode,
      extraMenu: undefined, // 바로결제하는 상품
      adultFlag: false, // 19+ 상품
      userCode: '', // 사용자코드
      storeGroupCode: '', // 매장코드
      cartStoreGroupCode: '',
      storeCode: '', // 매장코드
      gainFlag: false,
      bottomShow: true, // bottomMenu on/off
      companyType: this.$store.getters.companyType,
      appCartLength: 0,
      message: '',
      btnCase: 2,
      modalToggle: false,
      showDoubleBtnDialogFlag: false,
      onClickCancelBtn: undefined,
      singleImgFlag: undefined,
      userAdultFlag: this.$store.getters.userAdultFlag,
      openAreaDeliveryAble: this.$store.getters.openAreaDeliveryAble,
      pwdToggle: false // 비밀번호 변경 팝업
    }
  },
  computed: {
    qrType () { return this.$store.getters.qrType },
    riderInfo () { return this.$store.getters.riderInfo } // 배달비 정보
  },
  created () {
    this.$store.dispatch(CHANGE_LOGIN_AUTH_FLAG, false)
    // 최신 menuCode update
    if (this.menuCode) {
      this.$store.dispatch(SET_MENU_CODE, this.menuCode)
        .then(() => {
          if (this.appFlag) {
            this.menuDetail(this.menuCode)
          } else {
            this.requestMenuDetail(this.menuCode)
          }
        })
    } else {
      // yeonju.jin
      // back button으로 계속 돌아왔을 때 menuCode가 유지되지 않는 문제 수정
      // back button으로 돌아왔을 경우에는 menuCode가 undefined
      if (this.appFlag) {
        this.menuDetail(this.$store.getters.currentMenuCode)
      } else {
        this.requestMenuDetail(this.$store.getters.currentMenuCode)
      }
    }

    // 가맹점이 주문 불가능한 상태일 때
    if (!this.ableOrderFlag) {
      this.disableOrderMsg = this.companyType === 5 ? 'weCantTakeOrdersAtThisTime' : this.$store.getters.stateMsgForStore[0].replace('"', '')
    }
  },
  mounted () { // 스크롤 시, header에 상품 이름 표시
    window.backBtn = () => {
      this.backBtn()
    }
    document.querySelector('body').style.overscrollBehavior = 'contain' // 크롬 스크롤 새로고침 차단
    window.addEventListener('scroll', this.menuDetailScroll)
    // this.disableOrderMsg = this.companyType === 5 ? '지금은 주문이 불가합니다.' : DISABLE_MAKE_MENU_MSG
    if (this.appFlag) {
      this.cartList()
    }
  },
  beforeDestroy () {
    document.querySelector('body').removeAttribute('style') // 크롬 스크롤 새로고침 차단 style 제거
  },
  destroyed () {
    if (this.menu.originalImagePath !== '') {
      window.removeEventListener('scroll', this.menuDetailHeaderInvert)
    }
    window.removeEventListener('scroll', this.menuDetailScroll)
  },
  methods: {
    showSingleBtnDialog (message) {
      this.singleBtnMsgType = message
      this.onClickConfirmBtn = () => {
        this.pwdToggleChange()
        this.showSingleBtnDialogFlag = false
      }
      this.showSingleBtnDialogFlag = true
    },
    pwdToggleChange () {
      this.pwdToggle = !this.pwdToggle
    },
    backBtn () {
      if (this.pwdToggle) {
        this.pwdToggle = !this.pwdToggle
      } else if (this.allMenuToggle) {
        this.allMenuToggleChange()
      } else {
        this.$router.push({ name: 'MAIN' })
      }
    },
    optionalCheckBoxListFun (menuOption) {
      // 선택 옵션의 최소 개수 검사 시 사용할 optionalCheckBoxList 초기화 설정
      // props 로 OptionalOptionContainer 컴포넌트에서 업데이트

      // OptionalOption 없는 경우
      if (typeof menuOption === 'undefined') return

      menuOption.forEach((item) => {
        if (item.optionFlag === 4 && item.optionMin !== 0) {
          this.optionalCheckBoxList.push({
            menuOptionCode: item.menuOptionCode,
            menuOptionName: item.menuOptionName,
            isValidFlag: true
          })
        }
      })
    },
    async menuDetail (currentMenuCode) {
      if (currentMenuCode === undefined || currentMenuCode.length < 1) {
        // this.toast(this, NOT_EXIST_DATA)
        THROW_NON_EXIST_DATA()
        return
      }
      const req = {
        menuCode: currentMenuCode
      }
      const { data } = await service.menuDetail(req)
      if (data.resultCode == 0) {
        this.menu = data.menu
        this.price = this.menu.price
        this.storeCode = data.storeCode
        this.storeGroupCode = data.storeGroupCode
        this.userCode = data.userCode
        // 해당 상점의 주문은 가능한 경우
        if (this.ableOrderFlag) {
          // 현재 상품이 주문 가능한지 여부 확인
          if (this.menu.soldOutTodayFlag) {
            this.ableOrderFlag = false
            this.disableOrderMsg = 'soldOut'
          } else if (this.menu.outOfTimeFlag || data.resultCode === DISABLE_MAKE_MENU) {
            // 판매시간이 아니거나, 주문이 불가능한 상품인 경우
            this.ableOrderFlag = false
            this.disableOrderMsg = data.resultMsg
          }
        }
        if (this.menu.originalImagePath !== '') {
          window.addEventListener('scroll', this.menuDetailHeaderInvert)
        }
        // +19 상품인지 판단
        this.adultFlag = this.menu.adultFlag
        // optionalCheckBoxList 초기화 설정
        this.optionalCheckBoxListFun(this.menu.optionalOption)
      } else if (data.resultCode == 20) { // 조리불가
        this.menu = data.menu
        this.price = this.menu.price
        this.storeCode = data.storeCode
        this.storeGroupCode = data.storeGroupCode
        this.userCode = data.userCode
        // 해당 상점의 주문은 가능한 경우
        if (this.ableOrderFlag) {
          // 현재 상품이 주문 가능한지 여부 확인
          if (this.menu.soldOutTodayFlag) {
            this.ableOrderFlag = false
            this.disableOrderMsg = 'soldOut'
          } else if (this.menu.outOfTimeFlag || data.resultCode === DISABLE_MAKE_MENU) {
            // 판매시간이 아니거나, 주문이 불가능한 상품인 경우
            this.ableOrderFlag = false
            this.disableOrderMsg = data.resultMsg
          }
        }
        // +19 상품인지 판단
        this.adultFlag = this.menu.adultFlag
        // optionalCheckBoxList 초기화 설정
        this.optionalCheckBoxListFun(this.menu.optionalOption)
      }
    },
    reloadMainPage () {
      if (this.appFlag) {
        this.menuDetail(this.$store.getters.currentMenuCode)
      } else {
        this.requestMenuDetail(this.$store.getters.currentMenuCode)
      }
    },
    adultOnClickConfirmBtn () {
      this.confirmType()
      this.showAdultSingleBtnDialogFlag = false
    },
    showAddMenuDialog () { // 내 상품 추가 Dialog
      this.singleBtnMsgType = MSG_ADD_MY_MENU
      this.onClickConfirmBtn = () => { this.showSingleBtnDialogFlag = false }
      this.showSingleBtnDialogFlag = true
    },
    // showAdultMenuDialog (confirm) { // +19상품 주문 Dialog
    //   // this.singleBtnMsgType = MSG_ADULT_MENU
    //   // this.onClickConfirmBtn = () => {
    //   //   confirm()
    //   //   this.adultFlag = false // 한번 alert한 이후에는 pass
    //   //   this.showSingleBtnDialogFlag = false
    //   // }
    //   // this.showSingleBtnDialogFlag = true
    // },
    requestMenuDetail (currentMenuCode) { // 상품 상세 정보 요청
      if (currentMenuCode === undefined || currentMenuCode.length < 1) {
        // this.toast(this, NOT_EXIST_DATA)
        THROW_NON_EXIST_DATA()
        return
      }
      this.$store.dispatch(REQ_MENU_DETAIL, currentMenuCode)
        .then((response) => {
          this.menu = response.menu
          this.price = this.menu.price
          this.storeCode = response.storeCode
          this.storeGroupCode = response.storeGroupCode
          this.userCode = response.userCode
          // 해당 상점의 주문은 가능한 경우
          if (this.ableOrderFlag) {
            // 현재 상품이 주문 가능한지 여부 확인
            if (this.menu.soldOutTodayFlag) {
              this.ableOrderFlag = false
              this.disableOrderMsg = 'soldOut'
            } else if (this.menu.outOfTimeFlag || response.resultCode == DISABLE_MAKE_MENU) {
              // 판매시간이 아니거나, 주문이 불가능한 상품인 경우
              this.ableOrderFlag = false
              this.disableOrderMsg = response.resultMsg
            }
          }
          if (this.menu.originalImagePath !== '') {
            window.addEventListener('scroll', this.menuDetailHeaderInvert)
          }

          // +19 상품인지 판단
          this.adultFlag = this.menu.adultFlag
          // optionalCheckBoxList 초기화 설정
          this.optionalCheckBoxListFun(this.menu.optionalOption)
        })
    },
    // extraMenu일 때는 extraMenuFlag = true
    getMenu () { // 선택한 상품 refactoring
      const menu = CloneDeep.cloneDeep(this.menu)

      // 필요없는 데이터 제거
      delete menu.option
      delete menu.additionalOption
      delete menu.optionalOption
      delete menu.desc

      let menuKeyCode = menu.code
      menu.option = []
      // 무료/유료 옵션
      for (const option in this.options) {
        menuKeyCode += this.options[option].detailOption.menuDetailOptionCode
        menu.option.push(this.options[option])
      }
      // 추가옵션
      menu.additionalOption = []
      for (const option in this.extraOptions) {
        menuKeyCode += option
        menu.additionalOption.push(this.extraOptions[option])
      }
      // 선택옵션
      menu.optionalOption = []
      // let flag = true
      for (const option in this.optionalOptions) {
        menuKeyCode += option
        menu.optionalOption.push(this.optionalOptions[option])
        // if (flag) {
        //   menu.optionalOption.push(this.optionalOptions[option])
        //   flag = false
        // } else {
        //   delete this.optionalOptions[option].menuOptionCode
        //   menu.optionalOption.push(this.optionalOptions[option])
        // }
      }
      if (!this.appFlag) {
        menu.count = this.count // 선택한 상품 개수
      }
      menu.originPrice = this.price // 상품 기본 가격 + 옵션 가격
      menu.storeCode = this.currentStoreCode
      menu.sale = true // 상품 주문 가능
      if (this.orderDescMethod) menu.desc = ''
      return { menu: menu, key: menuKeyCode }
    },
    async soldoutCheck (type) {
      const menuId = []
      menuId.push(this.menu.menuId)
      const req = {
        menuId: menuId,
        app: this.appFlag ? 1 : 0
      }
      const { data } = await service.menuSoldoutCheck(req)
      if (data.resultCode == 0) {
        if (data.msg == 1) {
          this.singleBtnMsgType = 20
          this.onClickConfirmBtn = () => { this.showSingleBtnDialogFlag = false }
          this.showSingleBtnDialogFlag = true
        } else {
          if (type == 0) {
            this.checkAdultFlag(this.addCart)
          } else if (type == 1) {
            this.orderValid(this.order)
          }
        }
      }
    },
    orderValid (confirm) {
      // 선택옵션 && 19(성인인증) 검사
      let menuOptionName = ''
      let orderValidFlag = false
      this.optionalCheckBoxList.forEach((item) => {
        if (item.isValidFlag) {
          orderValidFlag = true
          if (!menuOptionName) menuOptionName = item.menuOptionName
        }
      })

      if (orderValidFlag) {
        this.toast(this, `${menuOptionName}의 최소 개수를 확인해주세요.`)
        return
      }
      if (this.menu.option) {
        const mandatoryOption = this.menu.option.filter(item => item.mandatoryFlag === 1)
        const optionCodeValues = mandatoryOption.map(item => item.menuOptionCode)
        if (optionCodeValues) {
          if (this.getMenu().menu.option.filter(item => optionCodeValues.includes(item.menuOptionCode)).length !== optionCodeValues.length) {
            this.toast(this, '필수 옵션을 확인해주세요.')
            return
          }
        }
      }

      this.checkAdultFlag(confirm) // 성인 인증
    },
    checkAdultFlag (confirm) { // 19+상품인지 확인
      if (this.adultFlag) {
        if (this.appFlag && this.isUser && this.userAdultFlag) {
          confirm()
        } else {
          this.confirmType = confirm
          this.adultSingleBtnMsgType = 18
          this.showAdultSingleBtnDialogFlag = true
        }
      } else {
        confirm()
      }
    },
    async cartList () {
      const req = {}
      const { data } = await service.appCartList(req)
      if (data.resultCode == 0) {
        this.appCartLength = data.cartList.length
        this.cartStoreGroupCode = data.storeGroupCode
        this.gainFlag = data.gainFlag
        this.cart = data.cartList.map(item => {
          const parsedCartInfo = JSON.parse(item.cartInfo)
          const appCartId = item.appCartId
          return {
            ...parsedCartInfo,
            appCartId
          }
        })
      }
    },
    async appAddCart () {
      const req = {
        cartInfo: JSON.stringify(this.getMenu()),
        price: this.price,
        count: this.count,
        qrType: this.qrType
      }
      const { data } = await service.appCartRegister(req)

      if (data.resultCode == 0) {
        THROW_MAIN(0, MENU_DETAIL_NAME, true)
      }
    },
    addCart () {
      if (this.appFlag) {
        // [시작] 카트에 담기 위해 선택옵션 검사 로직
        let menuOptionName = ''
        let orderValidFlag = false
        this.optionalCheckBoxList.forEach((item) => {
          if (item.isValidFlag) {
            orderValidFlag = true
            if (!menuOptionName) menuOptionName = item.menuOptionName
          }
        })

        if (orderValidFlag) {
          this.toast(this, `${menuOptionName}의 최소 개수를 확인해주세요.`)
          return
        }
        if (this.menu.option) {
          const mandatoryOption = this.menu.option.filter(item => item.mandatoryFlag === 1)
          const optionCodeValues = mandatoryOption.map(item => item.menuOptionCode)
          if (optionCodeValues) {
            if (this.getMenu().menu.option.filter(item => optionCodeValues.includes(item.menuOptionCode)).length !== optionCodeValues.length) {
              this.toast(this, '필수 옵션을 확인해주세요.')
              return
            }
          }
        }
        // [종료] 카트에 담기 위해 선택옵션 검사 로직

        if (this.cart === undefined || this.cart.length === 0) {
          this.appAddCart()
        } else {
          if (this.cart[0].menu.storeCode === this.getMenu().menu.storeCode) {
            if (this.gainFlag) {
              this.singleBtnMsgType = 16
              this.singleImgFlag = true
              this.onClickConfirmBtn = () => {
                this.showSingleBtnDialogFlag = false
                this.appAddCart()
              }
              this.showSingleBtnDialogFlag = true
            } else {
              this.appAddCart()
            }
          } else {
            const alertMsg = MESSAGE_DOUBLE_BUTTON[8]
            this.showDoubleBtnDialog(alertMsg, () => {
              this.hideDoubleBtnDialog()
              this.appAddCart()
            })
          }
        }
      } else {
        // [시작] 카트에 담기 위해 선택옵션 검사 로직
        let menuOptionName = ''
        let orderValidFlag = false
        this.optionalCheckBoxList.forEach((item) => {
          if (item.isValidFlag) {
            orderValidFlag = true
            if (!menuOptionName) menuOptionName = item.menuOptionName
          }
        })

        if (orderValidFlag) {
          this.toast(this, `${menuOptionName}의 최소 개수를 확인해주세요.`)
          return
        }
        if (this.menu.option) {
          const mandatoryOption = this.menu.option.filter(item => item.mandatoryFlag === 1)
          const optionCodeValues = mandatoryOption.map(item => item.menuOptionCode)
          if (optionCodeValues) {
            if (this.getMenu().menu.option.filter(item => optionCodeValues.includes(item.menuOptionCode)).length !== optionCodeValues.length) {
              this.toast(this, '필수 옵션을 확인해주세요.')
              return
            }
          }
        }
        // [종료] 카트에 담기 위해 선택옵션 검사 로직

        this.$store.dispatch(ADD_CART_ITEM, this.getMenu())
          .then(() => { THROW_MAIN(0, MENU_DETAIL_NAME, true) })
      }
      // 카트에 상품 추가 후, 메인 화면으로 이동
    },
    modalCancel () {
      this.modalToggle = false
    },
    modalCheck () {
      this.modalToggle = !this.modalToggle
      this.appAddCart()
    },
    openModal () {
      this.modalToggle = !this.modalToggle
      this.message = '카트에는 같은 가게의 상품만 담을 수 있습니다.'
    },
    showDoubleBtnDialog (message, confirmBtn) { // double btn show
      this.doubleBtnMsgType = message
      this.onClickConfirmBtn = confirmBtn
      this.onClickCancelBtn = this.hideDoubleBtnDialog
      this.showDoubleBtnDialogFlag = true
    },
    hideDoubleBtnDialog () {
      this.showDoubleBtnDialogFlag = false
    },
    order () { // 바로결제
      if (this.appFlag) {
        this.$store.dispatch(SET_DIRECTFLAG, true)
        this.$router.push({
          name: 'ORDER',
          params: {
            cartInfo: JSON.stringify(this.getMenu()), // 선택한 상품의 Unique code
            price: this.price,
            count: this.count
          }
        })
      } else {
        const menu = this.getMenu()
        const cart = {}
        payDirectly(cart, menu)
        this.$router.push({
          name: 'ORDER',
          params: {
            cart: cart, //기존
            totalPrice: menu.menu.originPrice * menu.menu.count, //기존,
          },
          query: {
            cartInfo: JSON.stringify(this.getMenu()), // 비회원 온누리 param
            price: this.price,// 비회원 온누리 param
            count: this.count// 비회원 온누리 param
          }
        })
        // THROW_ORDER(cart, menu.menu.originPrice * menu.menu.count, JSON.stringify(this.getMenu()))
        // }
      }
    }
    // order () {
    //   const menu = this.getMenu()
    //   if (this.cartMenuNo > 0) { // 카트에 상품이 있는 경우
    //     this.cart = CloneDeep.cloneDeep(this.$store.getters.cart)
    //     this.extraMenu = menu
    //     this.$store.dispatch(SET_CART_TYPE, false).then(() => this.createPopUp('#cart.cusLayer'))
    //   } else {
    //     // 카트에 상품이 없는 경우에는 주문서 화면으로 이동
    //     const cart = {}
    //     addCart(cart, menu)
    //     THROW_ORDER(cart, menu.menu.originPrice * menu.menu.count)
    //   }
    // }
  }
})
</script>
